import React from 'react';

const WaterIcon = (props) => {
  return (
    <img
      alt="Woda"
      src="/static/images/icons/services/water.svg"
      {...props}
    />
  );
};

export default WaterIcon;
